import { TAccount } from "../../../accounts/models";

export type TUserType = "PERSON" | "COMPANY";

export type TPaymentType = "PREPAID" | "POSTPAID";

export type TRole = "owner" | "admin" | "collaborator" | "support" | "master";

//pensar em arquivo com tipos universais...
export type TMeta = {
  currentPage: number;
  firstPage: number;
  firstPageUrl: string;
  lastPage: number;
  lastPageUrl: string;
  nextPageUrl: string | null;
  perPage: number;
  previousPageUrl: string | null;
  total: number;
};
export enum UserCategory {
  PERSON_PREPAID = "PERSON_PREPAID",
  COMPANY_PREPAID = "COMPANY_PREPAID",
  COMPANY_POSTPAID = "COMPANY_POSTPAID",
  PERSON_POSTPAID = "PERSON_POSTPAID",
}

export enum Permissions {
  ANALYSIS = "ANALYSIS",
  SCENARIOS = "SCENARIOS",
  ACCOUNTS = "ACCOUNTS",
  CONFIGURATIONS = "CONFIGURATIONS",
  CREDITS = "CREDITS",
  USERS = "USERS",
  SUPPORT = "SUPPORT",
  HISTORY = "HISTORY",
  AMBASSADOR = "AMBASSADOR",
  SEJAMBASSADOR = "SEJAMBASSADOR",
  BI = "BI",
}

export type TUser = {
  id: number;
  email: string;
  fullName: string | null;
  ambassador: boolean;
  phone: string | null;
  userType: TUserType;
  planId: number;
  paymentType: TPaymentType;
  asaasCustomerId: string;
  isVerified: boolean;
  accounts: TAccount[];
  createdAt: string;
  updatedAt: string;
  currentScenarioId: number;
  role: TRole;
};

export type TUserToken = {
  success: boolean;
  type?: string;
  message: string;
  value?: string;
};

export type TCriterioData = {
  scenarioId: number | null;
  accountId: number;
};

export type TUserRes = {
  data: TUser[];
  success: boolean;
  message: string;
  meta?: TMeta;
};
export type TSystemToken = {
  id: number;
  created_at: string;
  name?: string;
  token_preview?: string;
};
export type TSystemTokensResponse = {
  success: boolean;
  message: string;
  data?: TSystemToken[];
  meta?: TMeta;
};
export type TDeleteSystemTokenResponse = {
  success?: boolean;
  message: string;
};
